import React from 'react'

import { ZariContext } from '_zari/context'
import { Portlet } from '_zari/core'

import MainForm from './mainForm'

import { IdGen } from 'utils'

import * as UsuarioService from 'services/usuario.service'

const portletBreadcrumbs = [{ name: 'Perfil' }, { name: 'Información Personal' }]

const InformacionPersonalSection = () => {
  const __zariContext = React.useContext(ZariContext)

  const editarDataRef = React.useRef({})
  const [_keyMainForm, setKeyMainForm] = React.useState(IdGen.newId())

  React.useEffect(() => {
    UsuarioService.self
      .obtenerInfoPersonal()
      .then(({ data }) => {
        if (data) {
          editarDataRef.current = data
          setKeyMainForm(IdGen.newId())
        }
      })
      .catch(() => {
        __zariContext.snack('error', 'No se pudo obtener la información del usuario.')
      })
  }, [__zariContext])

  return (
    <Portlet>
      <Portlet.Header title='Perfil' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        <MainForm key={_keyMainForm} editarData={editarDataRef.current} />
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(InformacionPersonalSection)
